import axios from 'axios';

const api = axios.create({
    baseURL: process.env.REACT_APP_API_URL || 'https://confirmaai-api.animativa.tech',
});

// Request Interceptor
api.interceptors.request.use((config) => {
    const token = localStorage.getItem('token');
    if (token) {
        config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
}, (error) => {
    return Promise.reject(error);
});

// Response Interceptor
api.interceptors.response.use(
    (response) => {
        return response;
    },
    async (error) => {
        const originalRequest = error.config;
        
        // Se a resposta for 401 (Unauthorized) e não for uma tentativa de refresh já processada
        if (error.response && error.response.status === 401 && !originalRequest._retry) {
            originalRequest._retry = true;

            const refreshToken = localStorage.getItem('refreshToken');

            // Se não houver refresh token, logout forçado
            if (!refreshToken) {
                handleLogout();
                return Promise.reject(error);
            }

            try {
                // Tenta renovar o token
                // Usamos axios puro para evitar loop infinito nos interceptors da instância 'api'
                const response = await axios.post(
                    `${process.env.REACT_APP_API_URL || 'https://confirmaai-api.animativa.tech'}/auth/refresh`,
                    {},
                    {
                        headers: { Authorization: `Bearer ${refreshToken}` }
                    }
                );

                const { access_token } = response.data;

                // Atualiza o token no localStorage
                localStorage.setItem('token', access_token);

                // Atualiza o header da requisição original e refaz a chamada
                originalRequest.headers.Authorization = `Bearer ${access_token}`;
                
                // Atualiza também o header padrão da instância para chamadas futuras
                api.defaults.headers.common['Authorization'] = `Bearer ${access_token}`;

                return api(originalRequest);
            } catch (refreshError) {
                // Se o refresh falhar (token expirado ou inválido), logout forçado
                console.error("Refresh token falhou", refreshError);
                handleLogout();
                return Promise.reject(refreshError);
            }
        }
        
        // Verifica mensagens de erro específicas solicitadas
        // Caso o backend retorne 400 ou 500 mas com mensagem de erro de token
        if (error.response && error.response.data && error.response.data.msg) {
            const msg = typeof error.response.data.msg === 'string' ? error.response.data.msg.toLowerCase() : '';
            
            if (msg.includes("token has expired") || 
                msg.includes("token invalid") || 
                msg.includes("não foi possível listar treinamento") || 
                msg.includes("dados do dashboard indisponíveis")) {
                
                // Se o status não for 401, forçamos o tratamento como se fosse expiração
                if (error.response.status !== 401) {
                     handleLogout();
                }
            }
        }

        return Promise.reject(error);
    }
);

const handleLogout = () => {
    console.warn("Sessão expirada. Realizando logout forçado.");
    // Remove todos os dados de sessão
    localStorage.clear();
    sessionStorage.clear();
    
    // Limpa cookies (se houver)
    document.cookie.split(";").forEach((c) => {
        document.cookie = c.replace(/^ +/, "").replace(/=.*/, "=;expires=" + new Date().toUTCString() + ";path=/");
    });

    // Redireciona para login com mensagem
    if (!window.location.pathname.includes('/login')) {
        window.location.href = '/login?expired=true';
    }
};

export default api;
